import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareGoalsRoute: InvariantJiraRoute = {
	name: 'software-goals',
	exact: true,
	path: '/jira/software/projects/:projectKey/goals',
};
